import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `ControlSemen/getFiltrarModalInicio`, method: 'POST', body: values, token: token})
}
